import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdmin, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { useRolePermissionContext } from 'utils/providers/RolePermission';

import c from '../utils/constants';

export default function useGetPlanSummary(options = {}) {
  const { state } = useProvider();
  const { accountId } = useAdminParams();
  const { isAdmin } = useAdmin();

  const args = state;

  const {
    state: { rolePermissions },
  } = useRolePermissionContext();

  return useQuery({
    queryKey: [c.PLAN_SUMMARY],
    queryFn: async () => {
      if (!isAdmin && !state.isEmailAddressVerified) return null;

      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/plans/summary',
          },
          admin: {
            url: `api/v2/accounts/${accountId}/plans/summary`,
          },
        }),
      );

      return data?.data;
    },
    enabled: rolePermissions?.['plan-plans']?.status === 'ACTIVE',
    ...options,
  });
}
